<template>
  <div class="rank_area">
    <img v-if="currentUser.is_login != '0'" :src="'/img/rank/' + currentUser.rank + '.png'" class="rank_icon" @click="page('/my-page')">
    <span v-if="currentUser.is_login != '0'" class="pc">Your Rank is {{currentUser.rank_name}}</span>
    <span v-if="currentUser.is_login != '0'" class="sp">{{currentUser.rank_name}} Rank</span>
  </div>
</template>

<script>
export default {
  props: {
    currentUser: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    page(url) {
      this.$emit('changePage', url);
    },
  },
};
</script>

<style lang="scss" scoped>
.rank_area {
  display: flex;
  align-items: center;
  height: 84px;
  margin-left: 10px;
  min-width: 142px;
  @media screen and  (max-width: $tabletWidth) {
    margin-left: 5px;
    height: 78px;
    min-width: 92px;
  }
  .rank_icon {
    width: 50px;
    margin-right: 10px;
    cursor: pointer;
    @media screen and  (max-width: $tabletWidth) {
      width: 32px;
      margin-right: 5px;
    }
  }
  span {
    color: $white;
    margin-left: 10px;
    @media screen and  (max-width: $tabletWidth) {
      margin-left: 2px;
      font-size: 12px;
    }
  }
}
.pc {
  display: inline;
  @media screen and  (max-width: $tabletWidth) {
    display: none;
  }
}
.sp {
  display: none;
  @media screen and  (max-width: $tabletWidth) {
    display: inline;
  }
}
</style>
